var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSunIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 55,
    viewBox: "0 0 56 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 36.6667C25.5688 36.6667 23.2373 35.7009 21.5182 33.9818C19.7991 32.2627 18.8333 29.9312 18.8333 27.5C18.8333 25.0688 19.7991 22.7373 21.5182 21.0182C23.2373 19.2991 25.5688 18.3333 28 18.3333M7.375 27.5H9.66667M28 6.875V9.16667M28 45.8333V48.125M13.3336 12.8336L14.9377 14.4377M14.9377 40.5624L13.3336 42.1666M46.3333 16.0417L39.4583 27.5H48.625L41.75 38.9583",
    stroke: "#199CB5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSunIcon);
export default __webpack_public_path__ + "static/media/sun-icon.d88dca1dc0b8fab2c28c4a5d1d5f8fc9.svg";
export { ForwardRef as ReactComponent };